import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_layout_container = _resolveComponent("vxe-layout-container");
  return _openBlock(), _createBlock(_component_vxe_layout_container, _mergeProps(_ctx.$attrs, {
    vertical: $props.vertical,
    size: $props.size
  }), _createSlots({
    _: 2
  }, [_renderList(Object.keys(_ctx.$slots), key => {
    return {
      name: key,
      fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))])
    };
  })]), 1040, ["vertical", "size"]);
}